import { Component, OnDestroy, OnInit } from '@angular/core';
import { KpiSetService } from '../../../services/kpi-set.service';

@Component({
    selector: 'app-kpi-sets-index',
    templateUrl: 'index.component.html',
    styleUrls: [ 'index.component.scss' ]
})
export class KpiSetsIndexComponent implements OnInit, OnDestroy {

    protected title = 'Kpi sets';

    protected routePrefix = 'kpi-sets';

    protected pluginPrefix = 'eyewatch-kpi-sets-index';

    protected table;

    constructor(private kpiSetService: KpiSetService) {
    }

    ngOnInit() {
        this.createDatatable();
    }

    protected createDatatable() {
        this.table = {
            service: this.kpiSetService,
            columns: [ '*' ],
        };
    }

    ngOnDestroy() {
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/kpis/pages/kpi-sets/index/index.component.ts